import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CustomerModel } from "../models/user-cust-model";
import { ApiHandlerService } from "./api-handler.service";
import { Observable } from "rxjs";
import { IQueryParameters } from "../models/api-base-actions.interface";
import { CustomerUtilisationRegions, UserDepartmentResponse } from "../models/depart-region-depot.model";

@Injectable({
  providedIn: "root"
})
export class RestProvider {

  apiUrl = environment.checkItApiUrl;
  apiUrlDatalive = environment.dataliveApiUrl;

  public token = '';

  constructor(public http: HttpClient, private apiService: ApiHandlerService) { }

  /**
   * Generic API methods
   */
  get<T>(endpoint:string, params?: IQueryParameters): Observable<T> {
    return this.apiService.Get(endpoint, params);
  }

  post<T>(endpoint:string,body?:any): Observable<T>  {
    return this.apiService.Post(endpoint,body)
  }

  put(endpoint:string,body?:any){
    return this.apiService.Put(endpoint,body)
  }

  delete(endpoint:string){
    return this.apiService.Delete(endpoint,null)
  }
  /**
   * END Generic API methods
   */



  async getUserInfo(): Promise<any> {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${this.token}`);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    const data = await fetch(
      `${environment.dataliveApiUrl}/user/get_current_user/`,
      requestOptions
    );

    return await data.json()
  }


  GetCurrentUser(token?: string) {
    return new Promise<CustomerModel>((resolve, reject) => {
      let headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer  ' + (token ? token : this.token) });
      this.http.get(this.apiUrlDatalive + '/fmt/user/get_current_user_with_image/', { headers }).subscribe((res) => {
        resolve(res as CustomerModel);
      }, (err) => {
        reject(err);
      });
    });
  }


  GetUserDepartments(): Observable<UserDepartmentResponse> {
    return this.get<UserDepartmentResponse>(`${this.apiUrlDatalive}/user/departments/`)
  }

  GetUtilisationRegions(): Observable<CustomerUtilisationRegions> {
    return this.get<CustomerUtilisationRegions>(`${this.apiUrlDatalive}/customer/utilisation-report-regions/`)
  }



}
